import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import DepartmentDTO from '@src/adapters/dto/department/DepartmentDTO';
import useFindDepartmentsLazy from '@src/adapters/hooks/department/useFindDepartments';
import Layout from '@src/components/layout/Layout';
import { useCallback, useEffect, useState } from 'react';
import AddEdit from './components/AddEdit';

const PREFIX = 'Template';

const classes = {
  pageTitle: `${PREFIX}-pageTitle`,
  paper: `${PREFIX}-information`,
};

function Departments() {
  const { execute: find } = useFindDepartmentsLazy();
  const [recordCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [selectedPage, setSelectedPage] = useState(0);
  const [departments, setDepartments] = useState<DepartmentDTO[]>([]);
  const [selectedDepartment, setSelectedDepartment] = useState<DepartmentDTO>();
  const [addEditOpen, setAddEditOpen] = useState(false);

  const findDepartments = useCallback(() => {
    find({
      pageSize: rowsPerPage,
      currentPage: selectedPage,
    }).then((result) => {
      setDepartments(result.departments);
    });
  }, [find, rowsPerPage, selectedPage]);

  useEffect(() => {
    findDepartments();
  }, [findDepartments]);

  const handleAddClick = () => {
    setSelectedDepartment(undefined);
    setAddEditOpen(true);
  };

  const handleRowClick = (department: DepartmentDTO) => {
    setSelectedDepartment(department);
    setAddEditOpen(true);
  };

  const handleClose = (department: DepartmentDTO | undefined) => {
    setAddEditOpen(false);
    setSelectedDepartment(undefined);
    if (department) {
      setDepartments((prev) =>
        prev.some((dep) => dep.id === department.id)
          ? prev.map((item) =>
              item.id === department.id ? { ...item, ...department } : item
            )
          : [...prev, department]
      );
    }
  };

  return (
    <Layout>
      <Box
        sx={{
          padding: '0 20px 20px 20px',
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
        }}>
        <Typography variant="h4">Departments</Typography>
        <Button
          onClick={handleAddClick}
          color="secondary"
          variant="contained"
          size="medium">
          Add
        </Button>
      </Box>
      <Paper elevation={8} className={classes.paper}>
        <TableContainer>
          <Table
            aria-labelledby="tableTitle"
            size="small"
            aria-label="Contents table">
            <TableHead>
              <TableRow>
                <TableCell component="th" key="departmentName" align="left">
                  Department Name
                </TableCell>
                <TableCell component="th" key="isActive" align="left">
                  Is Active
                </TableCell>
                <TableCell component="th" key="activeRoles" align="left">
                  Active Roles
                </TableCell>
                <TableCell component="th" key="inactiveRoles" align="left">
                  Inactive Roles
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {departments.map((department, index) => {
                return (
                  <TableRow
                    hover
                    onClick={(event) => handleRowClick(department)}
                    role="checkbox"
                    tabIndex={-1}
                    key={department.id}
                    sx={{ cursor: 'pointer' }}>
                    <TableCell scope="row">{department.name}</TableCell>
                    <TableCell scope="row">
                      {department.isActive ? 'True' : 'False'}
                    </TableCell>
                    <TableCell scope="row">
                      {department.roles
                        .filter((r) => r.isActive)
                        .map((r) => r.name)
                        .join(', ')}
                    </TableCell>
                    <TableCell scope="row">
                      {department.roles
                        .filter((r) => !r.isActive)
                        .map((r) => r.name)
                        .join(', ')}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        {/* <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={recordCount}
                rowsPerPage={rowsPerPage}
                page={selectedPage}
                onPageChange={(event, number) => setSelectedPage(number)}
                onRowsPerPageChange={(event) => {
                  setRowsPerPage(parseInt(event.target.value, 10));
                  setSelectedPage(0);
                }}
              /> */}
      </Paper>
      <AddEdit
        department={selectedDepartment}
        close={handleClose}
        open={addEditOpen}
      />
    </Layout>
  );
}

export default Departments;
